import { awsApiInstance } from '../api/aws-api';
import axios, { AxiosError } from 'axios';
import { showToast } from '../components/toasts';
import useAuth from '../hooks/auth-hooks';

import { ITerminalId, ITerminalCardGroupResponse } from '../models/terminal.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Posts an updated list of linked card groups to a terminal
 * 
 * @param {ITerminalId} terminal the terminal/card group data
 * 
 * @returns api response
 */
const PostTerminalCardGroup = async ( terminal: ITerminalId ): Promise<ITerminalCardGroupResponse> => {
  try {
    const { userId } = useAuth()!;

    const modelData = {
      wpID: userId,
      terminalId: terminal.terminalID!,
      CardGroups: terminal.cardGroups
    };

    const { data } = await awsApiInstance.post(`/terminal/${terminal.terminalID}/card-group`, modelData);

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error updating terminal card group data');
    throw(error);
  }
}

export default PostTerminalCardGroup;
